var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('el-backtop',[_c('div',{staticClass:"backTop"},[_c('i',{staticClass:"el-icon-top"}),_c('div',[_vm._v("回顶部")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }